@if (buySuccessModalData) {
  <div
    class="c-buySuccess"
    [ngClass]="purchasedCoins ? 'c-buySuccess--coins' : 'c-buySuccess--gems'">
    <div class="c-buySuccess__layer c-buySuccess__frontLayer--{{ purchasedCoins ? 'coins' : 'gems' }}"></div>
    <div class="c-buySuccess__layer c-buySuccess__backLayer--{{ purchasedCoins ? 'coins' : 'gems' }}"></div>
    <div class="c-buySuccess__info">
      <div class="modal-title">
        {{ 'home.shop.modals.buy-success.title' | translate | uppercase }}
      </div>
      <div class="modal-subtitle">
        {{ 'home.shop.modals.buy-success.message' | translate }}
      </div>
    </div>
    <div class="c-buySuccess__amount">
      <div
        class="modal-currency"
        [ngClass]="purchasedCoins ? 'modal-currency-credits' : 'modal-currency-gems'"></div>
      <div class="modal-amount">
        @if (purchasedCoins) {
          <span>{{ buySuccessModalData.reward.credits | number: '1.0-0' : ('common.culture' | translate) }}</span>
        }
        @if (!purchasedCoins) {
          <span>{{ buySuccessModalData.reward.gems | number: '1.0-0' : ('common.culture' | translate) }}</span>
        }
      </div>
    </div>
    <div class="c-buySuccess__container">
      <slotcom-button
        data-testid="slotcom-lobby-redeemPurchase-button"
        class="c-button--pink"
        (safeClick)="redeem()"
        audioType="reward">
        {{ 'home.buttons.collect' | translate | uppercase }}
      </slotcom-button>
    </div>
  </div>
}
